
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buy/[sid]/map",
      function () {
        return require("private-next-pages/buy/[sid]/map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buy/[sid]/map"])
      });
    }
  